export default {
  fetchError: {
    code: -1,
    msg: '没有详细信息'
  }
};



// WEBPACK FOOTER //
// ./src/stores/global/_state.js